import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function FeaturedTool({ tool, category, zip }) {
  if (!tool || !tool.slug) return null;

  const params = new URLSearchParams();
  if (category) params.set("category", category);
  if (zip) params.set("zip", zip);

  const href = `/tools/${tool.slug}${params.toString() ? `?${params}` : ""}`;

  return (
    <section
    style={{
        margin: "0px 0px 00px 0px",
        display: "flex",
        justifyContent: "center",
    }}
    >

      <div className="container">
        <Link
          to={href}
          style={{
            textDecoration: "none",
            color: "inherit",
            justifyContent: "center",
          }}
        >
          <div className="featured-tool-box"
            >

            {/* Optional eyebrow */}
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: "#3690ff",
                marginBottom: 12,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
              }}
            >
              Featured Planning Tool
            </div>

            {tool.icon && (
              <img
                src={tool.icon}
                alt={tool.label}
                style={{
                  width: 96,
                  height: "auto",
                  marginBottom: 16,
                }}
              />
            )}

            <h2
              style={{
                margin: 0,
                fontSize: "1.8rem",
                fontWeight: 700,
                color: "#1385ff",
                  textAlign: "center",
              }}
            >
              {tool.label || tool.heading}
            </h2>

            {tool.body && (
              <p
                style={{
                  maxWidth: "90%",
                  fontSize: "1.05rem",
                  lineHeight: 1.5,
                  color: "#555",
                  textAlign: "center",
                }}
              >
                {tool.body}
              </p>
            )}
          </div>
        </Link>
      </div>
    </section>
  );
}

FeaturedTool.propTypes = {
  tool: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    label: PropTypes.string,
    heading: PropTypes.string,
    body: PropTypes.string,
    icon: PropTypes.string,
  }),
  category: PropTypes.string,
  zip: PropTypes.string,
};
